import { ColumnFilterOrDisplayType, ConfigColumns2 } from "../../types/configColumns2";
import { momentDtoToLocalStringByCulture } from "../../aplUtils/dateHelper";
import { Culture } from "../../types/culture";
import { ConsumptionDetail } from "../../types/consumptionDetail";
import { capitalizeFirstLetter, stringContains } from "../../aplUtils/stringUtills";
import { translateString } from "../../translations/gridTranslationHelper";

const getConsumptionDetailsColumns = (siteId: number, culture: Culture) => {
    let columns: ConfigColumns2[];

    const rensderSentToSap = (data: ConsumptionDetail, type: ColumnFilterOrDisplayType | undefined) => {
        if (stringContains(data.sentToSap, "1")) return capitalizeFirstLetter(translateString("rxg_Yes", culture));
        else if (stringContains(data.sentToSap, "0")) return capitalizeFirstLetter(translateString("rxg_No", culture));
        else return "";
    };

    if (siteId === 7) {
        columns = [
            { data: "consumptionId", visible: false, width: "0px", title: "consumptionId" },
            {
                data: "dtoDateIssued",
                className: "nowrap",
                render: function (data: ConsumptionDetail, type: ColumnFilterOrDisplayType | undefined) {
                    if (data.dtoDateIssued == null) {
                        return "";
                    } else {
                        return type !== "display" ? data.dtoDateIssued : momentDtoToLocalStringByCulture(data.dtoDateIssued, culture);
                    }
                },
                width: "10%",
                title: "dateIn"
            },
            {
                data: "dtoDateConsumed",
                className: "nowrap",
                render: function (data: ConsumptionDetail, type: ColumnFilterOrDisplayType | undefined) {
                    if (data.dtoDateConsumed == null) {
                        return "";
                    } else {
                        return type !== "display" ? data.dtoDateConsumed : momentDtoToLocalStringByCulture(data.dtoDateConsumed!, culture);
                    }
                },
                width: "10%",
                title: "dateEnd"
            },
            { data: "lot", className: "nowrap", width: "10%", title: "lot" },
            { data: "sequence", className: "nowrap", width: "10%", title: "rank" },

            { data: "description", className: "nowrap", width: "24%", title: "partCode" },
            { data: "batch", className: "nowrap", width: "10%", title: "batchNr" },
            { data: "sscc", className: "nowrap", width: "10%", title: "sscc" },
            { data: "quantity", className: "nowrap", width: "10%", title: "quantity" },

            { data: "unit", className: "nowrap", width: "10%", title: "unit" },
            { data: "sentToSap", className: "nowrap", width: "10%", title: "sendToSAP", render: rensderSentToSap }
        ];
    } else {
        columns = [
            { data: "consumptionId", visible: false, width: "0px", title: "consumptionId" },
            {
                data: "dtoDateIssued",
                className: "nowrap",
                render: function (data: ConsumptionDetail, type: ColumnFilterOrDisplayType | undefined) {
                    if (data.dtoDateIssued == null) {
                        return "";
                    } else {
                        return type !== "display" ? data.dtoDateIssued : momentDtoToLocalStringByCulture(data.dtoDateIssued, culture);
                    }
                },
                width: "10%",
                title: "dateIn"
            },
            {
                data: "dtoDateConsumed",
                className: "nowrap",
                render: function (data: ConsumptionDetail, type: ColumnFilterOrDisplayType | undefined) {
                    if (data.dtoDateConsumed == null) {
                        return "";
                    } else {
                        return type !== "display" ? data.dtoDateConsumed : momentDtoToLocalStringByCulture(data.dtoDateConsumed, culture);
                    }
                },
                width: "10%",
                title: "dateEnd"
            },
            { data: "sscc", className: "nowrap", width: "10%", title: "sscc" },
            { data: "sequence", className: "nowrap", width: "10%", title: "rank" },

            { data: "description", className: "nowrap", width: "24%", title: "partCode" },
            { data: "quantity", className: "nowrap", width: "10%", title: "quantity" },
            { data: "batch", className: "nowrap", width: "10%", title: "batchNr" },
            { data: "lot", className: "nowrap", width: "10%", title: "lot" },

            { data: "unit", className: "nowrap", width: "10%", title: "unit" },
            { data: "sentToSap", className: "nowrap", width: "10%", title: "sendToSAP", render: rensderSentToSap }
        ];
    }

    return columns;
};

const getConsumptionDefaultOrder = (siteId: number, culture: string): [[number, string]] => {
    if (siteId === 7) {
        return [[1, "desc"]];
    } else {
        return [[1, "desc"]];
    }
};

export { getConsumptionDetailsColumns, getConsumptionDefaultOrder };
